import { useContext } from 'react';
import { PlaybackStoreApi, PlaybackStoreContext } from './playback.context';

/**
 * Same as usePlaybackStoreApiContext but returns undefined instead of throwing
 * when no PlaybackProvider exists in the tree.
 */

export function useOptionalPlaybackStoreApiContext(): PlaybackStoreApi | undefined {
  return useContext(PlaybackStoreContext)?.store;
}
